import { useCallback, useState } from "react";

interface UseFileNameValidationProps {
    errorMessage: string;
    requiredMessage?: string;
}

const useFileNameValidation = ({ errorMessage, requiredMessage }: UseFileNameValidationProps) => {
    const [fileName, setFileName] = useState<string>("");
    const [error, setError] = useState<string | null>(null);
    const [requiredError, setRequiredError] = useState<string | null>(null);

    const validateFileName = (name: string): boolean => {
        const invalidFileName = /[\/\\]/;

        if (invalidFileName.test(name)) {
            setError(errorMessage);
            return false;
        }

        setError(null);
        return true;
    };

    const handleFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFileName(value);
        validateFileName(value);
        if (value.trim()) {
            setRequiredError(null);
        }
    };

    // The dialogs refuse to send without a name; this makes the refusal visible instead of a dead button.
    const checkFileNameRequired = (): boolean => {
        if (fileName.trim()) {
            return true;
        }

        setRequiredError(requiredMessage ?? null);
        return false;
    };

    const resetRequiredError = useCallback(() => setRequiredError(null), []);

    return {
        fileName,
        error,
        requiredError,
        setFileName,
        handleFileNameChange,
        checkFileNameRequired,
        resetRequiredError,
    };
};

export default useFileNameValidation;
